import { utils } from '@deeptrue-frontend/ui';
import React from 'react';
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';

import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';
import { ReactComponent as WidgetIcon } from 'assets/icons/widget.svg';
import ReactDOMServer from 'react-dom/server';

const registerTranslatableInput = () => {
  // @ts-ignore
  const TranslatableInput = utils.survey.widgets.TranslatableInput.widget;

  // create model for new question type
  class QuestionTranslatableModel extends Question {
    getType() {
      return 'dttranslatabletext';
    }
    get translatableType() {
      return this.getPropertyValue('translatableType');
    }
    set translatableType(val) {
      this.setPropertyValue('translatableType', val);
    }
  }

  // set display title for question type
  localization.getLocale('').qt.dttranslatabletext = 'Translatable Input';

  const svg = ReactDOMServer.renderToString(<WidgetIcon />);
  SvgRegistry.registerIconFromSvg('dttranslatabletext', svg);

  // this serializes the class into JSON
  Serializer.addClass(
    'dttranslatabletext',
    [
      {
        name: 'translatableType',
      },
    ],
    function () {
      return new QuestionTranslatableModel('');
    },
    'question'
  );

  SurveyQuestionEditorDefinition.definition.dttranslatabletext = {
    properties: [{ name: 'translatableType', tab: 'layout' }],
  };

  ElementFactory.Instance.registerElement('dttranslatabletext', (name) => {
    return new QuestionTranslatableModel(name);
  });
  Serializer.addProperties('dttranslatabletext', [
    {
      name: 'languageExpression',
      default: 'Blanguages',
      category: 'Expressions',
    },

    {
      name: 'genericText',
      category: 'Locales',
      default: 'Please provide answer in ',
      isLocalizable: true,
    },
    {
      name: 'placeholderText',
      category: 'Locales',
      default: '',
      isLocalizable: true,
    },
    {
      name: 'validationErrorFieldText',
      category: 'Locales',
      default: 'Please provide proper value',
      isLocalizable: true,
    },
    {
      name: 'validationErrorText',
      category: 'Locales',
      default: 'Please provide proper value',
      isLocalizable: true,
    },
    {
      name: 'validationType',
      category: 'Validation',
      default: 'none',
      choices: ['none', 'email', 'url'],
    },
    {
      name: 'inputType',
      category: 'Validation',
      default: 'single',
      choices: ['single', 'multiline', 'editor'],
    },
  ]);
  class SurveyQuestionTranslatable extends SurveyQuestionElementBase {
    constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
    }
    get question() {
      return this.questionBase;
    }
    get value() {
      return this.question.value;
    }

    get type() {
      // @ts-ignore
      return this.question.translatableInputType;
    }
    handleTranslatableChange = (data: any) => {
      this.question.value = data;
    };

    // support readOnly and designMode
    get style() {
      return this.question.getPropertyValue('readOnly') ||
        this.question.isDesignMode
        ? {
            pointerEvents: 'none',
          }
        : undefined;
    }

    renderElement() {
      return (
        // @ts-ignore
        <TranslatableInput question={this.question} requiredTextError="ddd" />
      );
    }
  }
  ReactQuestionFactory.Instance.registerQuestion(
    'dttranslatabletext',
    (props: any) => {
      return React.createElement(SurveyQuestionTranslatable, props);
    }
  );

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'dttranslatabletext';
    },
    getJSON: function () {
      return { type: 'dttranslatabletext' };
    },
  });
};

export default registerTranslatableInput;
